import React from 'react'
import CrystalBall from './CrystalBall'
import './Header.css'

interface HeaderProps {
  theme?: 'neutral' | 'boy' | 'girl'
}

const Header: React.FC<HeaderProps> = ({ theme = 'neutral' }) => {  return (
    <header className={`header header--${theme}`}>
      <div className="container">
        <div className="header-content">
          <div className="header-crystal-ball">
            <CrystalBall size={80} animated={true} glowing={true} />
          </div>
          <div className="logo">
            <h1 className="logo-text">Gender Genie</h1>
          </div>
          <p className="tagline">
            Discover your baby's gender with AI-powered nub theory analysis
          </p>
        </div>
      </div>
    </header>
  )
}

export default Header
